import {buildspriteLibraryURLSyIds} from '../lib/bp_assets_util.js';
import {BP_THEME, JR_THEME} from '../reducers/topic-project';

const processHrefParams = function (hrefParams) {
    const topicProjectHref = {};
    const bpDataHref = {};
    if (hrefParams) {
        // TOPIC PROJECT HREFS
        if (hrefParams.library) {
            topicProjectHref.spriteLibraryURLS =
                buildspriteLibraryURLSyIds(hrefParams.topic, hrefParams.library, false, hrefParams.api_domain);
        } else if (hrefParams.jr_library) {
            topicProjectHref.spriteLibraryURLS =
                buildspriteLibraryURLSyIds(hrefParams.jr_topic, hrefParams.jr_library, true, hrefParams.api_domain);
        }
        if (hrefParams.local_save) {
            topicProjectHref.localSave = hrefParams.local_save;
        }
        if (hrefParams.viewer_mode) {
            topicProjectHref.viewerMode = (hrefParams.viewer_mode === 'true');
        }
        if (hrefParams.full_screen) {
            topicProjectHref.playerMode = (hrefParams.full_screen === 'true');
        }
        if (hrefParams.product) {
            topicProjectHref.theme = (hrefParams.product === 'bpjr') ? JR_THEME : BP_THEME;
        }

        // BP DATA HREFS
        if (hrefParams.topic) {
            bpDataHref.topicId = hrefParams.topic;
        } else if (hrefParams.jr_topic) {
            bpDataHref.topicId = hrefParams.jr_topic;
            bpDataHref.isJr = true;
        }
        if (hrefParams.user_type) {
            bpDataHref.userType = hrefParams.user_type;
        }
        if (hrefParams.feature_resource_id) {
            bpDataHref.featureResourceId = hrefParams.feature_resource_id;
        }
        if (hrefParams.product) {
            bpDataHref.product = hrefParams.product;
        }
        if (hrefParams.activity_id) {
            bpDataHref.activityId = hrefParams.activity_id;
        }
        if (hrefParams.project_type) {
            bpDataHref.projectType = hrefParams.project_type;
        }
        if (hrefParams.domain) {
            bpDataHref.domain = hrefParams.domain;
        }
        if (hrefParams.api_domain) {
            bpDataHref.apiDomain = hrefParams.api_domain;
        }
        if (hrefParams.assignment_parts_id) {
            bpDataHref.isAssignment = true;
            bpDataHref.assignmentPartsId = hrefParams.assignment_parts_id;
        }
    }
    return {
        topicProjectHref: topicProjectHref,
        bpDataHref: bpDataHref
    };
};

export {
    processHrefParams
};
